(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof Splide !== 'undefined') {
      let featuredCollectionsSlider;
      
      function initSlider() {
        const slider = document.getElementById('featured-collections-slider');
        if (!slider) return;
        
        featuredCollectionsSlider = new Splide('#featured-collections-slider', {
          destroy: true,
          breakpoints: {
            1024: {
              type: 'loop',
              clone: 1,
              gap: 12,
              perPage: 1,
              padding: { right: '28%' },
              destroy: false,
              pagination: true,
              autoplay: true,
              interval: 4000,
              speed: 500,
              loop: true,
              arrows: false,
              pauseOnHover: false,
              pauseOnFocus: false,
            }
          }
        }).mount();
      }
      
      initSlider();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Splide slider
    if (typeof Splide !== 'undefined') {
      new Splide('#featured-products-slider', {
        type: 'loop',
        perPage: 4,
        gap: 12,
        clone: 2,
        autoplay: true,
        interval: 4000,
        speed: 500,
        padding: { right: 30 },
        loop: true,
        arrows: false,
        pagination: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          1024: {
            perPage: 2,
            padding: { right: '15%' },
          },
          768: {
            perPage: 1,
            padding: { right: '28%' },
          },
        }
      }).mount();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-news"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof Splide !== 'undefined') {
      let featuredCollectionsSlider;

      function initSlider() {
        const slider = document.getElementById('latest-news-slider');
        if (!slider) return;

        featuredCollectionsSlider = new Splide('#latest-news-slider', {
          destroy: true,
          breakpoints: {
            1024: {
              type: 'loop',
              clone: 1,
              gap: 12,
              perPage: 1,
              padding: { right: '28%' },
              destroy: false,
              pagination: false,
              autoplay: true,
              interval: 4000,
              speed: 500,
              loop: true,
              arrows: false,
              pauseOnHover: false,
              pauseOnFocus: false,
            }
          }
        }).mount();
      }

      initSlider();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Splide slider
    if (typeof Splide !== 'undefined') {
      new Splide('#main-visual-slider', {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        interval: 4000,
        speed: 500,
        loop: true,
        arrows: false,
        pagination: true,
        pauseOnHover: false,
        pauseOnFocus: false,
      }).mount();
    }

    // Video play/pause control and time display
    var video = document.querySelector('.main-visual__video-element');
    var button = document.querySelector('.main-visual__video-button');
    var timeDisplay = document.querySelector('.main-visual__video-time');
    function formatTime(sec) {
      sec = Math.max(0, sec);
      var m = Math.floor(sec / 60);
      var s = Math.floor(sec % 60);
      return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    if (video && button) {
      button.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          button.textContent = 'PAUSE';
        } else {
          video.pause();
          button.textContent = 'PLAY';
        }
      });

      // Update time display
      if (timeDisplay) {
        var updateTime = function() {
          var remaining = (video.duration && !isNaN(video.duration)) ? (video.duration - video.currentTime) : 0;
          timeDisplay.textContent = formatTime(remaining);
        };
        video.addEventListener('timeupdate', updateTime);
        video.addEventListener('loadedmetadata', updateTime);
        // Set initial time
        updateTime();
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
